// @ts-nocheck

import React from 'react';
import styled, { css } from 'styled-components';

import { Mymatch } from '../../assets/svg';
import { Target } from '../../client';
import { ON_MY_MATCH_TOGGLE_TRANSITION_DURATION } from '../../constants/ui/mymatch';
import theme from '../../styled-components/dark';
import { MatchViewModeSwitch as MatchViewModeSwitchTheme } from '../../styled-components/dark/match';
import { type MyMatchAPIErrorId } from '../../types/mymatch';
import Switch from '../common/Switch';
import MyMatchDynamicBackground, {
  MyMatchDynamicBackgroundLeftImgClassName,
  MyMatchDynamicBackgroundRadialClassName,
  MyMatchDynamicBackgroundRightImgClassName,
} from '../MyMatchDynamicBackground';
import MyMatchErrorModal from '../MyMatchErrorModal';

const StyleReceiver = styled.div`
  --MyMatchDynamicBackground-defaultBackgroundColor: var(
    --MatchViewModeSwitch-dynamicDefaultBackgroundColor,
    ${theme.MatchBetGroup.backgroundColor}
  );
`;

const Wrapper = styled.div`
  position: relative;

  border-radius: 1em;
  color: white;

  overflow: hidden;

  cursor: pointer;

  ${!Target.__MOBILE__
    ? css`
        & > * {
          transition: filter 300ms ease-in-out;
        }

        &:hover {
          filter: brightness(110%);
        }
      `
    : undefined}
`;

const StyledMyMatchIcon = styled(Mymatch)`
  height: 1.3em;
  width: 5em;
  margin-right: 0.6em;
`;

const StyledSwitch = styled(Switch)`
  --Switch-colorTransitionDuration: ${ON_MY_MATCH_TOGGLE_TRANSITION_DURATION}ms;
`;

const Background = styled(MyMatchDynamicBackground)`
  border-radius: inherit;

  & .${MyMatchDynamicBackgroundRadialClassName} {
    left: 0%;
    top: -150%;
    width: 400%;
  }

  & .${MyMatchDynamicBackgroundLeftImgClassName} {
    display: none;
  }

  & .${MyMatchDynamicBackgroundRightImgClassName} {
    transform: scale(3);
    left: 100%;
    top: 20%;
  }
`;

const Content = styled.div`
  position: relative;
  display: flex;

  padding: 0.5em 0.5em 0.5em 0.75em;

  & > * {
    font-size: 90%;
  }
`;

type MatchViewModeSwitchProps = {
  className?: string;
  toggled: boolean;
  showErrorModal: boolean;
  showUserNotConnectedModal: boolean;
  onToggle: () => void;
  onCloseErrorModal: () => void;
  onCloseUserNotConnectedModal: () => void;
  matchMMErrorId: MyMatchAPIErrorId;
};

const MatchViewModeSwitch = ({
  className = '',
  toggled,
  showErrorModal,
  onToggle,
  onCloseErrorModal,
  matchMMErrorId,
}: MatchViewModeSwitchProps) => {
  return (
    <>
      <StyleReceiver>
        <Wrapper className={className} onClick={onToggle} $toggled={toggled} data-testid="match-view-mode-switch">
          <Background isActive={toggled} />
          <Content>
            <StyledMyMatchIcon />
            <StyledSwitch toggled={toggled} theme={MatchViewModeSwitchTheme} />
          </Content>
        </Wrapper>
      </StyleReceiver>
      <MyMatchErrorModal show={showErrorModal} matchMMErrorId={matchMMErrorId} onClose={onCloseErrorModal} />
    </>
  );
};

export default MatchViewModeSwitch;
